import {
  TFeedbackDeactivationSend,
  TFeedbackDeactivationType,
  TFeedbackEmailSend,
  TFeedbackSend
} from '@/models/feedback';
import APIService from '../api';

export default class FeedbackService extends APIService {
  host() {
    return this.servicesHost();
  }

  sendFeedback(data: TFeedbackSend) {
    return this.post('/feedback/platform', data);
  }

  sendFeedbackDeactivation(
    type: TFeedbackDeactivationType,
    data: TFeedbackDeactivationSend
  ) {
    return this.post(`/feedback/${type}`, data);
  }

  getFeedback() {
    return this.get('/feedback/platform/latest');
  }

  sendFeedbackEmail(data: TFeedbackEmailSend) {
    return this.post('/feedback/platform/email', data);
  }

  getFeedbackEmail(businessId: string, customerId: string) {
    return this.get(
      `/feedback/platform/email?businessId=${businessId}&customerId=${customerId}`
    );
  }
}
